import React from "react";
import {RootDispatchContext} from '../providers';

function useDispatchRoot() {
    return React.useContext(RootDispatchContext);
}

export {useDispatchRoot}
